import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from './supabase';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

const REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes

export default function App() {
  const [user, setUser] = useState(null);
  const [data, setData] = useState(null);
  const [dataStatus, setDataStatus] = useState('loading'); // loading | live | error
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchData = useCallback(async () => {
    setDataStatus('loading');
    try {
      const res = await fetch('/.netlify/functions/sheets');
      if (!res.ok) throw new Error('Failed to fetch');
      const json = await res.json();
      setData(json);
      setLastUpdated(new Date());
      setDataStatus('live');
    } catch (e) {
      setDataStatus('error');
    }
  }, []);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [fetchData]);

  const handleLogin = (userData) => setUser(userData);
  const handleLogout = async () => {
    setUser(null);
  };

  if (!user) return <Login onLogin={handleLogin} />;

  return (
    <Dashboard
      user={user}
      data={data}
      dataStatus={dataStatus}
      lastUpdated={lastUpdated}
      onLogout={handleLogout}
      onRefresh={fetchData}
    />
  );
}
